import {Menu, MenuItem} from "@mui/material"
import chroma from "chroma-js"
import React, {FC} from "react"
import {getAllUserRouteStatus, UserRouteStatus} from "../../../models/UserClimbingEvent"
import {ClimbingEvent} from "../../../models/ClimbingEvent";

type Props = {
  anchor?: HTMLElement,
  handleClose: () => void,
  setStatusOnRoute: (status: UserRouteStatus) => void,
  event: ClimbingEvent
}

export const EventRouteSelectMenu: FC<Props> = ({anchor, handleClose, setStatusOnRoute, event}) => {

  const getTextColor = (color: string) => chroma(color).luminance() > 0.5 ? "black" : "white";

  const statuses = getAllUserRouteStatus(event)

  return (
    <Menu
      id="menu-appbar"
      anchorEl={anchor}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchor)}
      onClose={handleClose}
      style={{borderRadius: 0}}
      MenuListProps={{
        style: {backgroundColor: getAllUserRouteStatus(event)[0].color}
      }}


    >
      {
        statuses.map(status =>
          <MenuItem key={"status-" + status.status} sx={{
            backgroundColor: status.color,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: getTextColor(status.color)
          }} onClick={() => setStatusOnRoute(status.status)}>
            {React.createElement(status.icon, {style: {color: getTextColor(status.color)}})}
            {status.status!==UserRouteStatus.NOTHING && status.label}
          </MenuItem>)
      }
    </Menu>
  )
}